// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".descriptive_training_form-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin: 15px 0px; }\n", ""]);
// Exports
module.exports = exports;
